// Mock data for KOLD AIR LTD website

export const businessInfo = {
  name: "KOLD AIR LTD",
  shortName: "Kold Air",
  tagline: "Design · Install · Service",
  phone: "07583 933146",
  email: null,
  address: "Cottingham, East Yorkshire",
  area: "Hull, East Yorkshire & surrounding areas",
  rating: 5.0,
  reviewCount: 8,
  hours: {
    weekdays: "Monday – Friday: 8:00 AM – 5:00 PM",
    saturday: "Saturday: By appointment",
    sunday: "Sunday: Closed",
    summary: "Mon–Fri 8am–5pm",
  },
  description:
    "Kold Air Ltd is a family run air conditioning specialist based in Cottingham, serving Yorkshire and the surrounding areas. We design, install, maintain and repair AC systems across commercial, residential, industrial and modular settings — keeping you cool when it counts.",
  yearsExperience: null,
  website: null,
  logoText: "KOLD AIR",
  logoImage:
    "https://customer-assets.emergentagent.com/job_f9f3197a-b0d7-4602-8676-650c7b1bf20f/artifacts/toarh3o7_logo.jpeg",
  premisesPhoto: null,
  facebook: "https://www.facebook.com/profile.php?id=61578460164849",
  linkedin: "https://www.linkedin.com/in/kris-russell-57b7a4101",
  instagram: "https://www.instagram.com/kold.air.ltd/",
  certification: "F-Gas & NVQ3 Qualified · Member of REFCOM",
};

export const navLinks = [
  { label: "Home", href: "#home" },
  { label: "About Us", href: "#about" },
  { label: "Our Services", href: "#services" },
  { label: "Gallery", href: "#gallery" },
  { label: "Reviews", href: "#testimonials" },
  { label: "Contact Us", href: "#contact" },
];

const stock = (id) =>
  `https://images.unsplash.com/photo-${id}?w=1400&q=80&auto=format&fit=crop`;

export const services = [
  {
    id: 1,
    title: "Commercial Install",
    description:
      "AC for offices, retail, hospitality and beyond — system design that scales with your business.",
    image:
      "https://customer-assets.emergentagent.com/job_7ca9c69e-a6f7-4a4c-97b1-87caf3119fbf/artifacts/0uq77gd7_commercial%20install.jpeg",
    details: {
      intro:
        "From small offices to multi-floor retail and hospitality fit-outs, we deliver fully managed commercial AC projects — designed for performance, energy efficiency and minimal disruption to your business.",
      included: [
        "Office, retail and hospitality AC fit-outs",
        "Cassette, ceiling and ducted systems",
        "VRV / VRF multi-unit installations",
        "Building Regs and F-Gas compliant",
        "Out-of-hours fitting available",
        "Lifetime aftercare and servicing plans",
      ],
    },
  },
  {
    id: 2,
    title: "Residential Install",
    description:
      "Sleek, quiet AC systems designed and installed in homes — keep every room comfortable year-round.",
    image:
      "https://customer-assets.emergentagent.com/job_7ca9c69e-a6f7-4a4c-97b1-87caf3119fbf/artifacts/45g3w0t6_res%20ins.jpeg",
    details: {
      intro:
        "Whether it's a single bedroom split, a multi-zone whole-house system or a discreet ducted setup, we design and install residential AC that looks great, runs quiet and slashes summer discomfort.",
      included: [
        "Heating & cooling",
        "Free in-home survey and design",
        "Wall, ceiling and floor-mount units",
        "Multi-zone and whole-house systems",
        "Concealed ducted installations",
        "Smart Wi-Fi controls and zoning",
      ],
    },
  },
  {
    id: 3,
    title: "Modular",
    description:
      "Climate control for modular offices, site cabins, classrooms and portable buildings.",
    image:
      "https://customer-assets.emergentagent.com/job_7ca9c69e-a6f7-4a4c-97b1-87caf3119fbf/artifacts/ak72hxrc_modular.jpeg",
    icon: "Box",
    details: {
      intro:
        "Modular buildings need flexible, compact climate control. We supply and install AC for portable offices, site cabins, classrooms and modular accommodation — easy to commission, easy to relocate.",
      included: [
        "Site cabin and welfare unit AC",
        "Modular classroom systems",
        "Portable office cooling and heating",
        "Quick-install split systems",
        "Through-wall and roof-mount options",
        "Move-with-the-building re-installs",
      ],
    },
  },
  {
    id: 4,
    title: "Industrial",
    description:
      "Heavy-duty AC and process cooling for warehouses, factories and server rooms.",
    image:
      "https://customer-assets.emergentagent.com/job_7ca9c69e-a6f7-4a4c-97b1-87caf3119fbf/artifacts/51lxov5q_industrial.jpeg",
    details: {
      intro:
        "Industrial environments demand robust climate control. From server room precision cooling to large warehouse and factory ventilation, we design and install systems built to perform in tough conditions, day in, day out.",
      included: [
        "Server room precision cooling",
        "Warehouse and factory units",
        "Industrial chillers and heat pumps",
        "Process cooling applications",
        "Robust outdoor condenser installs",
        "High-temperature and dusty environments",
      ],
    },
  },
  {
    id: 5,
    title: "Maintenance & Service",
    description:
      "Planned preventative maintenance, repairs and breakdown call-outs across all major makes.",
    image:
      "https://customer-assets.emergentagent.com/job_7ca9c69e-a6f7-4a4c-97b1-87caf3119fbf/artifacts/hus7xkjk_maintinence%20and%20service.jpeg",
    details: {
      intro:
        "Regular servicing keeps AC systems running at peak efficiency, extends their lifespan and prevents costly breakdowns. We cover one-off services, annual contracts and emergency repairs across all major manufacturers.",
      included: [
        "Annual maintenance contracts",
        "Filter cleaning and replacement",
        "Refrigerant leak checks, repairs and re-gas",
        "Safe gas removal and decommissioning",
        "Coil and condenser cleaning",
        "Breakdown call-outs and repairs",
      ],
    },
  },
  {
    id: 6,
    title: "Cellar Cooling",
    description:
      "Dedicated cooling for pubs, restaurants and beer cellars — keep your stock at the right temperature 24/7.",
    image:
      "https://customer-assets.emergentagent.com/job_7ca9c69e-a6f7-4a4c-97b1-87caf3119fbf/artifacts/9ujl1lvr_cellar%20cooling.jpeg",
    icon: "Snowflake",
    details: {
      intro:
        "Cellar cooling is a specialism of ours — we install and service dedicated cellar cooling systems for pubs, bars, restaurants and food storage, keeping product perfectly chilled day in, day out.",
      included: [
        "Beer / wine cellar systems",
        "Food storage cooling",
        "Through-wall and remote condenser setups",
        "Temperature monitoring and alarms",
        "Emergency call-outs for failures",
        "Annual cellar cooling maintenance",
      ],
    },
  },
  {
    id: 7,
    title: "Ventilation & Ducting",
    description:
      "Mechanical ventilation, extract and ducted distribution — designed and fitted to spec.",
    image:
      "https://customer-assets.emergentagent.com/job_7ca9c69e-a6f7-4a4c-97b1-87caf3119fbf/artifacts/efd89t6c_venting%20and%20ducting.jpeg",
    icon: "Wind",
    details: {
      intro:
        "From whole-building MVHR to concealed ducted AC distribution, we design and install ventilation and ducting systems that move air efficiently and comply with current regs.",
      included: [
        "MVHR and supply / extract systems",
        "Concealed and bulkhead ducting",
        "Plenum, grille and diffuser fit",
        "Existing ductwork cleaning",
        "Air balancing and commissioning",
      ],
    },
  },
  {
    id: 8,
    title: "Sub Contracting & Pipework",
    description:
      "AHU pipework, commissioning and skilled engineering support for large-scale projects.",
    image:
      "https://customer-assets.emergentagent.com/job_7ca9c69e-a6f7-4a4c-97b1-87caf3119fbf/artifacts/7baznkxa_air%20handling%20units.jpeg",
    icon: "Fan",
    details: {
      intro:
        "We work as a trusted sub contractor on large-scale projects — providing AHU pipework, commissioning and additional skilled engineering support to help main contractors deliver on time.",
      included: [
        "AHU pipework",
        "Assistance with large projects",
        "Commissioning services",
        "Additional experience",
        "Trusted and skilled engineers",
      ],
    },
  },
];

export const whyChooseUs = [
  {
    id: 1,
    title: "F-Gas & NVQ3 Qualified",
    description: "NVQ3 qualified refrigeration & AC engineer — every install regulation-compliant",
    icon: "Shield",
  },
  {
    id: 2,
    title: "5.0★ Google Rating",
    description: "Every customer so far rates us 5 stars on Google",
    icon: "Star",
  },
  {
    id: 3,
    title: "Yorkshire-Wide Coverage",
    description: "Based in Cottingham — serving Hull, Yorkshire & beyond",
    icon: "MapPin",
  },
  {
    id: 4,
    title: "Free, No-Obligation Quotes",
    description: "No-obligation quotes for every project",
    icon: "FileText",
  },
  {
    id: 5,
    title: "Residential & Commercial",
    description: "Homes, offices, retail, industrial and modular — all covered",
    icon: "Hammer",
  },
  {
    id: 6,
    title: "Aftercare & Servicing",
    description: "Annual maintenance plans to keep your AC running perfectly",
    icon: "Wrench",
  },
];

export const processSteps = [
  {
    step: 1,
    title: "Get in Touch",
    description:
      "Call, email or message — tell us about the space you need cooling.",
  },
  {
    step: 2,
    title: "Free Survey",
    description:
      "We visit, measure, calculate the heat load and recommend the right system.",
  },
  {
    step: 3,
    title: "Design & Quote",
    description:
      "Clear written quote with options — equipment, performance and price all laid out.",
  },
  {
    step: 4,
    title: "Install & Aftercare",
    description:
      "Clean, professional install, full commissioning and ongoing maintenance plans.",
  },
];

export const portfolioItems = [];

export const testimonials = [
  {
    id: 1,
    name: "Jonny Adlard",
    text: "Kold Air installed 2 units in our property and the service was brilliant. Fast, clean and professional looking installation inside and out. AC units working perfectly and would definitely recommend using Kold Air!",
    rating: 5,
    project: "AC Installation",
    timeAgo: "3 weeks ago",
  },
  {
    id: 2,
    name: "Jim Harris",
    text: "Absolutely brilliant service from start to finish. Friendly, professional and really knows their stuff. The install was tidy, completed on time and the difference the air conditioning has made is huge. Great communication throughout.",
    rating: 5,
    project: "AC Installation",
    timeAgo: "3 weeks ago",
  },
  {
    id: 3,
    name: "Kristina Amaira",
    text: "Absolutely outstanding service from start to finish. The team installed our AC units professionally and efficiently, and the quality of the work was excellent. They were punctual, tidy, friendly, and took the time to explain everything.",
    rating: 5,
    project: "AC Installation",
    timeAgo: "3 weeks ago",
  },
  {
    id: 4,
    name: "Amp up Electrical Limited",
    text: "Absolutely fantastic service from start to finish! The team was professional, friendly, and incredibly knowledgeable. They arrived on time, explained everything clearly, and completed the work to a very high standard.",
    rating: 5,
    project: "Commercial Install",
    timeAgo: "3 weeks ago",
  },
  {
    id: 5,
    name: "Matthew Monday",
    text: "Wonderful experience with Kold Air Ltd from my initial query right through to completion. Kristian was extremely attentive in his detail when assessing our requirements and subsequent advice on the system that would best suit.",
    rating: 5,
    project: "AC Installation",
    timeAgo: "2 months ago",
  },
  {
    id: 6,
    name: "Jordan Sellers",
    text: "Excellent service from Kris — professional from start to finish. Highly recommended.",
    rating: 5,
    project: "AC Installation",
    timeAgo: "3 weeks ago",
  },
];

export const faqItems = [
  {
    id: 1,
    question: "Are you F-Gas certified?",
    answer:
      "Yes — our engineer is an F-Gas and NVQ3 qualified refrigeration and air conditioning engineer, and Kold Air Ltd is a member of REFCOM. Anyone working with refrigerant gases in the UK must hold valid F-Gas certification, and our work is properly qualified and governed.",
  },
  {
    id: 2,
    question: "What areas do you cover?",
    answer:
      "We're based in Cottingham, East Yorkshire and cover Kingston upon Hull, the East Riding of Yorkshire and the surrounding areas. Call us on 07583 933146 to confirm coverage for your postcode.",
  },
  {
    id: 3,
    question: "Do you do commercial as well as home installs?",
    answer:
      "Absolutely. We cover residential, commercial, industrial and modular installations — everything from a single split unit in a bedroom to multi-zone VRV systems in offices and retail spaces.",
  },
  {
    id: 4,
    question: "How quickly can you install a new AC system?",
    answer:
      "For most residential split installs we can survey, quote and install within 1–2 weeks. Commercial projects depend on scope, but we'll always give you a clear timescale upfront. Repairs can usually be attended within days.",
  },
  {
    id: 5,
    question: "Are surveys and quotes free?",
    answer:
      "Yes — every site survey and quote is completely free and no-obligation. We'll visit your property, calculate the heat load, recommend the right system and send a detailed written quote.",
  },
];

export const brands = [
  {
    name: "Daikin",
    logo: "https://customer-assets.emergentagent.com/job_7ca9c69e-a6f7-4a4c-97b1-87caf3119fbf/artifacts/g7juefth_WhatsApp%20Image%202026-06-04%20at%2015.15.27%20%281%29.jpeg",
  },
  {
    name: "Mitsubishi Electric",
    logo: "https://customer-assets.emergentagent.com/job_7ca9c69e-a6f7-4a4c-97b1-87caf3119fbf/artifacts/jus4xonv_WhatsApp%20Image%202026-06-04%20at%2015.15.27%20%282%29.jpeg",
  },
  {
    name: "Panasonic",
    logo: "https://customer-assets.emergentagent.com/job_7ca9c69e-a6f7-4a4c-97b1-87caf3119fbf/artifacts/uk49mf6r_WhatsApp%20Image%202026-06-04%20at%2015.15.28%20%281%29.jpeg",
  },
  {
    name: "Mitsubishi Heavy Industries",
    logo: "https://customer-assets.emergentagent.com/job_7ca9c69e-a6f7-4a4c-97b1-87caf3119fbf/artifacts/5zfdcry9_WhatsApp%20Image%202026-06-04%20at%2015.15.28%20%282%29.jpeg",
  },
  {
    name: "Midea",
    logo: "https://customer-assets.emergentagent.com/job_7ca9c69e-a6f7-4a4c-97b1-87caf3119fbf/artifacts/u70x2mdj_WhatsApp%20Image%202026-06-04%20at%2015.15.28.jpeg",
  },
  {
    name: "Fujitsu",
    logo: "https://customer-assets.emergentagent.com/job_7ca9c69e-a6f7-4a4c-97b1-87caf3119fbf/artifacts/87q4nosw_WhatsApp%20Image%202026-06-04%20at%2015.15.27%20%283%29.jpeg",
  },
];

// REFCOM is a governing body, not an AC brand — shown separately as a credential.
export const refcomLogo =
  "https://customer-assets.emergentagent.com/job_7ca9c69e-a6f7-4a4c-97b1-87caf3119fbf/artifacts/b15il99w_WhatsApp%20Image%202026-06-04%20at%2015.15.27.jpeg";

export const galleryImages = [
  {
    src: "https://customer-assets.emergentagent.com/job_f9f3197a-b0d7-4602-8676-650c7b1bf20f/artifacts/06xa41iq_WhatsApp%20Image%202026-06-19%20at%2017.49.43%20%281%29.jpeg",
    alt: "Silver wall-mounted split AC above patio doors",
    caption: "Wall-Mounted Split — Modern Interior",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_f9f3197a-b0d7-4602-8676-650c7b1bf20f/artifacts/lc8y4z41_WhatsApp%20Image%202026-06-19%20at%2017.49.44.jpeg",
    alt: "Fujitsu wall-mounted split in a bedroom",
    caption: "Residential Bedroom Install",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_f9f3197a-b0d7-4602-8676-650c7b1bf20f/artifacts/vboqxctt_WhatsApp%20Image%202026-06-19%20at%2017.49.45%20%282%29.jpeg",
    alt: "Fujitsu split AC in a clean medical room",
    caption: "Commercial Clean-Room Install",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_f9f3197a-b0d7-4602-8676-650c7b1bf20f/artifacts/l89s4n7b_WhatsApp%20Image%202026-06-19%20at%2017.49.43.jpeg",
    alt: "AHU pipework and pressure gauges",
    caption: "AHU Pipework & Commissioning",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_f9f3197a-b0d7-4602-8676-650c7b1bf20f/artifacts/5z8i7sog_WhatsApp%20Image%202026-06-19%20at%2017.49.45%20%281%29.jpeg",
    alt: "Airedale outdoor condenser on rooftop grating",
    caption: "Rooftop Condenser Install",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_f9f3197a-b0d7-4602-8676-650c7b1bf20f/artifacts/8jym6lal_WhatsApp%20Image%202026-06-19%20at%2017.49.47.jpeg",
    alt: "Plant room air handling unit ductwork and insulated pipework",
    caption: "Plant Room — Ductwork & Pipework",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_f9f3197a-b0d7-4602-8676-650c7b1bf20f/artifacts/t7vs8m28_WhatsApp%20Image%202026-06-19%20at%2017.49.48%20%281%29.jpeg",
    alt: "Daikin external condensers mounted on a commercial building wall",
    caption: "Commercial — External Condensers",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_f9f3197a-b0d7-4602-8676-650c7b1bf20f/artifacts/3ta7e1sy_WhatsApp%20Image%202026-06-19%20at%2017.49.48.jpeg",
    alt: "Ceiling cassette AC unit in a suspended ceiling",
    caption: "Commercial — Ceiling Cassette",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_f9f3197a-b0d7-4602-8676-650c7b1bf20f/artifacts/s2kgpkaq_WhatsApp%20Image%202026-06-19%20at%2017.49.49%20%281%29.jpeg",
    alt: "Wall-mounted split AC in an office",
    caption: "Office Split Install",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_f9f3197a-b0d7-4602-8676-650c7b1bf20f/artifacts/8n187joh_WhatsApp%20Image%202026-06-19%20at%2017.49.49%20%282%29.jpeg",
    alt: "Daikin external condenser on a residential brick wall",
    caption: "Residential — Daikin Condenser",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_f9f3197a-b0d7-4602-8676-650c7b1bf20f/artifacts/bbvp2adr_WhatsApp%20Image%202026-06-19%20at%2017.49.51%20%281%29.jpeg",
    alt: "Fujitsu Airstage split AC in a conservatory",
    caption: "Conservatory Split Install",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_f9f3197a-b0d7-4602-8676-650c7b1bf20f/artifacts/c9r7ym5p_WhatsApp%20Image%202026-06-19%20at%2017.49.51.jpeg",
    alt: "Mitsubishi Electric outdoor condenser on a cedar-clad wall",
    caption: "Residential — Mitsubishi Electric Condenser",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_f9f3197a-b0d7-4602-8676-650c7b1bf20f/artifacts/4fh1hxdb_WhatsApp%20Image%202026-06-19%20at%2017.49.52%20%281%29.jpeg",
    alt: "Fujitsu Airstage wall-mounted split AC in a room",
    caption: "Residential Wall Split",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_f9f3197a-b0d7-4602-8676-650c7b1bf20f/artifacts/l45psw4i_WhatsApp%20Image%202026-06-19%20at%2017.49.52%20%282%29.jpeg",
    alt: "LG Artcool Gallery picture-frame AC unit in a bedroom",
    caption: "LG Artcool Gallery — Bedroom",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_f9f3197a-b0d7-4602-8676-650c7b1bf20f/artifacts/2x1ojlp7_WhatsApp%20Image%202026-06-19%20at%2017.49.52.jpeg",
    alt: "Fujitsu Airstage outdoor condenser on a patio",
    caption: "Residential — Fujitsu Condenser",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_f9f3197a-b0d7-4602-8676-650c7b1bf20f/artifacts/tvmcsaw3_WhatsApp%20Image%202026-06-19%20at%2017.49.58.jpeg",
    alt: "Fujitsu Airstage outdoor condenser on a brick wall",
    caption: "Commercial — Fujitsu Condenser",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_f9f3197a-b0d7-4602-8676-650c7b1bf20f/artifacts/q50ppfg4_WhatsApp%20Image%202026-06-19%20at%2017.49.59%20%282%29.jpeg",
    alt: "Fujitsu Airstage outdoor condenser with Kold Air sticker",
    caption: "Commercial — Kold Air Fitted Condenser",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_f9f3197a-b0d7-4602-8676-650c7b1bf20f/artifacts/srkdckrw_WhatsApp%20Image%202026-06-19%20at%2017.49.59%20%281%29.jpeg",
    alt: "Fujitsu Airstage wall-mounted split in an office",
    caption: "Office Split Install",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_f9f3197a-b0d7-4602-8676-650c7b1bf20f/artifacts/dn5yktfx_WhatsApp%20Image%202026-06-19%20at%2017.49.59%20%283%29.jpeg",
    alt: "Indoor AC unit opened up for servicing",
    caption: "Maintenance & Service",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_f9f3197a-b0d7-4602-8676-650c7b1bf20f/artifacts/5ausgd6z_WhatsApp%20Image%202026-06-19%20at%2017.49.59.jpeg",
    alt: "Fujitsu wall controller set to Cool at 18 degrees",
    caption: "Wall Controller — Cooling Mode",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_f9f3197a-b0d7-4602-8676-650c7b1bf20f/artifacts/p1q05a23_WhatsApp%20Image%202026-06-19%20at%2017.50.07%20%283%29.jpeg",
    alt: "Wall-mounted split inside a modular cabin office",
    caption: "Modular Office — Interior Split",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_f9f3197a-b0d7-4602-8676-650c7b1bf20f/artifacts/ruvltefq_WhatsApp%20Image%202026-06-19%20at%2017.50.07%20%284%29.jpeg",
    alt: "Fujitsu Airstage outdoor condenser on a modular cabin",
    caption: "Modular — Fujitsu Condenser",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_f9f3197a-b0d7-4602-8676-650c7b1bf20f/artifacts/wcyt7k9y_WhatsApp%20Image%202026-06-19%20at%2017.50.07.jpeg",
    alt: "Caged Fujitsu outdoor unit on a modular cabin in a warehouse",
    caption: "Modular — Caged Condenser",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_f9f3197a-b0d7-4602-8676-650c7b1bf20f/artifacts/mrrnpz45_WhatsApp%20Image%202026-06-19%20at%2017.50.07%20%285%29.jpeg",
    alt: "Midea outdoor condenser on a brick wall",
    caption: "Residential — Midea Condenser",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_f9f3197a-b0d7-4602-8676-650c7b1bf20f/artifacts/dpczoedu_WhatsApp%20Image%202026-06-19%20at%2017.50.08%20%281%29.jpeg",
    alt: "Mitsubishi Electric outdoor condenser on a brick wall",
    caption: "Residential — Mitsubishi Electric Condenser",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_f9f3197a-b0d7-4602-8676-650c7b1bf20f/artifacts/h0weabhx_WhatsApp%20Image%202026-06-19%20at%2017.50.08%20%283%29.jpeg",
    alt: "Multiple Mitsubishi condensers being serviced from a scissor lift",
    caption: "Commercial — Multi-Unit Service",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_f9f3197a-b0d7-4602-8676-650c7b1bf20f/artifacts/zt7camzn_WhatsApp%20Image%202026-06-19%20at%2017.50.08.jpeg",
    alt: "Daikin outdoor condenser on a chevron timber-clad wall",
    caption: "Daikin Condenser — Timber Cladding",
  },
];

export const heroImages = {
  main: "https://customer-assets.emergentagent.com/job_7ca9c69e-a6f7-4a4c-97b1-87caf3119fbf/artifacts/4kupy02f_6.jpg",
  mainFallback:
    "https://customer-assets.emergentagent.com/job_7ca9c69e-a6f7-4a4c-97b1-87caf3119fbf/artifacts/4kupy02f_6.jpg",
  mainVideo: null,
  about:
    "https://customer-assets.emergentagent.com/job_7ca9c69e-a6f7-4a4c-97b1-87caf3119fbf/artifacts/slrhyxun_hero.jpeg",
};
